import {createStore, applyMiddleware, AnyAction} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import thunk, {ThunkDispatch} from 'redux-thunk';
import rootReducer from './reducers';

const middleware = [thunk];

export const store = createStore(
    rootReducer,
    {},
    composeWithDevTools(applyMiddleware(...middleware)),
);

export type RootState = ReturnType<typeof store.getState>

// ThunkDispatch, not typeof store.dispatch: legacy createStore does not thread the
// middleware's type through, so dispatching a thunk would be a type error.
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>

